// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact{text-align:center;padding-top:10px}.g-recaptcha{background:none!important;-webkit-appearance:none}", ""]);
// Exports
module.exports = exports;
